import { useQuery } from '@tanstack/react-query';
import { useCallback, useContext } from 'react';
import { AdminSettings } from 'types';
import { ADMIN_SETTINGS_KEY, apiUrl, fetchWithAuth, USE_QUERY_STALE_TIME } from 'utils';
import { AuthContext } from 'contexts';

export function useAdminSettings() {
  const authContext = useContext(AuthContext);

  const queryFn = useCallback(async (): Promise<AdminSettings> => {
    const response = await fetchWithAuth(`${apiUrl}/admin-settings`);

    const ret: AdminSettings = await response.json();

    if (!ret) {
      throw new Error('Failed to find AdminSettings');
    }

    return ret;
  }, []);

  return useQuery({
    queryKey: [ADMIN_SETTINGS_KEY],
    queryFn,
    staleTime: USE_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: authContext.isAuthenticated,
  });
}
